module.exports = __webpack_public_path__ + "static/media/271.c52e93dc.webp";